import 'intl-tel-input/dist/css/intlTelInput.css';
import { formatPhoneNumber } from './format-phone-number';
import { getInvalidPhoneNumberMessage } from './phone-validation-messages';
import { getDefaultCountryCode } from './default-country-code';
let intlTelInput = null;
const PHONE_INPUT_SELECTOR = '.inputTel, input[type="tel"], input[name="mobile_number_c"], input[name="phone_number_c"]';
const applyNeatNationalValue = (input, instance) => {
    if (!intlTelInput) {
        return;
    }
    const national = instance.getNumber(intlTelInput.NUMBER_FORMAT.NATIONAL);
    if (national) {
        input.value = national.replace(/^0/, '');
    }
};
const validateAndNormalize = (input) => {
    const instance = intlTelInput?.getInstance(input);
    if (!instance || !intlTelInput?.utils) {
        input.setCustomValidity('');
        return true;
    }
    const raw = input.value.trim();
    if (raw === '') {
        input.setCustomValidity('');
        return true;
    }
    if (instance.isValidNumber()) {
        applyNeatNationalValue(input, instance);
        input.setCustomValidity('');
        return true;
    }
    if (raw.startsWith('0')) {
        input.value = raw.replace(/^0/, '');
        if (instance.isValidNumber()) {
            applyNeatNationalValue(input, instance);
            input.setCustomValidity('');
            return true;
        }
        input.value = raw;
    }
    input.setCustomValidity(getInvalidPhoneNumberMessage());
    return false;
};
const initInput = (input, defaultCountryCode) => {
    if (!intlTelInput) {
        return;
    }
    try {
        intlTelInput(input, {
            loadUtils: () => import('intl-tel-input/utils'),
            initialCountry: defaultCountryCode,
        });
        input.addEventListener('blur', () => validateAndNormalize(input));
        input.addEventListener('countrychange', () => validateAndNormalize(input));
        input.addEventListener('input', () => input.setCustomValidity(''));
    }
    catch (error) {
        console.error('Error initializing intl-tel-input:', error);
    }
};
export const initInternationalPhoneInputs = () => {
    const inputs = document.querySelectorAll(PHONE_INPUT_SELECTOR);
    if (inputs.length === 0) {
        return;
    }
    const defaultCountryCode = getDefaultCountryCode();
    if (!defaultCountryCode) {
        console.error('Default country code could not be determined');
        return;
    }
    import('intl-tel-input').then((module) => {
        intlTelInput = module.default;
        inputs.forEach((input) => initInput(input, defaultCountryCode));
    });
};
export const applyPhoneNumbersToFormData = (formContainer, data) => {
    const inputs = formContainer.querySelectorAll(PHONE_INPUT_SELECTOR);
    let valid = true;
    inputs.forEach((input) => {
        const name = input.name;
        const raw = input.value.trim();
        if (!name || raw === '') {
            return;
        }
        const instance = intlTelInput?.getInstance(input);
        if (!instance || !intlTelInput?.utils) {
            data[name] = formatPhoneNumber(raw);
            return;
        }
        if (!validateAndNormalize(input)) {
            valid = false;
            return;
        }
        const e164 = instance.getNumber(intlTelInput.NUMBER_FORMAT.E164);
        if (e164) {
            data[name] = e164;
        }
    });
    return valid;
};
export const reportPhoneValidity = (formContainer) => {
    const inputs = formContainer.querySelectorAll(PHONE_INPUT_SELECTOR);
    for (const input of Array.from(inputs)) {
        if (!input.checkValidity()) {
            input.reportValidity();
            return false;
        }
    }
    return true;
};
